var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitchDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3144 11.1428L16.8858 14.5714H13.4572L10.4572 17.5714V14.5714H6.6001V1.71426H20.3144V11.1428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74287 0L1.45715 4.28571V19.7143H6.60001V24L10.8857 19.7143H14.3143L22.0286 12V0H5.74287ZM20.3143 11.1429L16.8857 14.5714H13.4572L10.4572 17.5714V14.5714H6.60001V1.71429H20.3143V11.1429Z",
    fill: "#9146FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7429 4.71426H16.0286V9.85712H17.7429V4.71426Z",
    fill: "#9146FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0285 4.71429H11.3142V9.85715H13.0285V4.71429Z",
    fill: "#9146FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchDefault);
export default __webpack_public_path__ + "static/media/twitchDefault.3396b6e62c513abe88d93edeba7f13e2.svg";
export { ForwardRef as ReactComponent };